import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, MessageCircle, ArrowLeft, GraduationCap, Clock } from "lucide-react";
import { Seo } from "@/components/Seo";

const WA_LINK = "https://wa.me/919810981090?text=Hi!%20I%20just%20booked%20my%20free%20career%20session.";

export default function ThankYouPage() {
  const { state } = useLocation();
  const interest = state?.interest;
  const bestTime = state?.best_time;

  useEffect(() => {
    if (window.fbq) window.fbq("track", "Lead");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-16" style={{ background: "var(--bg-primary)" }} data-testid="thank-you-page">
      <Seo title="Thank You — Tech Career Institute" robots="noindex, nofollow" />
      <div className="text-center max-w-md w-full">
        <img
          src="/images/logo.png"
          alt="Institute logo"
          className="mx-auto w-16 h-16 rounded-2xl object-cover mb-8"
          style={{ border: "1px solid var(--input-border)" }}
          data-testid="thank-you-logo"
        />
        <div
          className="mx-auto w-20 h-20 rounded-full flex items-center justify-center mb-6"
          style={{ background: "rgba(14, 217, 181, 0.1)", border: "1px solid rgba(14, 217, 181, 0.35)", boxShadow: "0 0 40px rgba(14, 217, 181, 0.2)" }}
          data-testid="thank-you-check"
        >
          <CheckCircle2 size={40} style={{ color: "var(--accent)" }} strokeWidth={2} />
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold uppercase text-white" data-testid="thank-you-headline">
          You're <span className="glow-accent" style={{ color: "var(--accent)" }}>All Set!</span>
        </h1>
        <p className="mt-5 text-base sm:text-lg leading-relaxed" style={{ color: "var(--text-body)" }} data-testid="thank-you-message">
          Thank you for booking your free career session. Our counsellor will call you within 24 hours at your
          preferred time slot.
        </p>

        {(interest || bestTime) && (
          <div className="mt-8 rounded-2xl p-5 text-left space-y-3.5" style={{ background: "var(--bg-card)", border: "1px solid var(--input-border)" }} data-testid="thank-you-summary">
            {interest && (
              <p className="flex items-center gap-3 text-sm" style={{ color: "var(--text-body)" }} data-testid="summary-interest">
                <GraduationCap size={17} className="shrink-0" style={{ color: "var(--accent)" }} />
                You're interested in: <strong className="text-white font-semibold">{interest}</strong>
              </p>
            )}
            {bestTime && (
              <p className="flex items-center gap-3 text-sm" style={{ color: "var(--text-body)" }} data-testid="summary-time">
                <Clock size={17} className="shrink-0" style={{ color: "var(--accent)" }} />
                We'll call between: <strong className="text-white font-semibold">{bestTime}</strong>
              </p>
            )}
          </div>
        )}

        <div className="mt-9 flex flex-col gap-3">
          <a
            data-testid="thank-you-whatsapp-button"
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-base font-bold w-full"
          >
            <MessageCircle size={18} />
            Chat on WhatsApp Now
          </a>
          <Link
            to="/"
            data-testid="thank-you-home-link"
            className="inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-base font-semibold transition-colors hover:text-white w-full"
            style={{ border: "1px solid var(--input-border)", color: "var(--text-body)" }}
          >
            <ArrowLeft size={17} style={{ color: "var(--accent)" }} />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
